import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class OrderItemService {
  constructor(public http: Http) {}

  deleteItem(order_id: number, id: number) {
    return this.http.delete(`${API_URL}/api/v1/orders/${order_id}/order_items/${id}`).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/order_items.ts